module.exports = __webpack_public_path__ + "img/img3.9850bdd7.svg";